export default "__VITE_ASSET__9215b3f3__"